import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import BasicTable from '../../../../atoms/BasicTable'
import { targetManagedNoteStyle } from './shared'

function JobPrimaryKeys ({ job, assignedTarget }) {
  const primaryKeys = useMemo(() => {
    if (!job.configuration?.primaryKey) return null
    if (Array.isArray(job.configuration.primaryKey)) {
      return job.configuration.primaryKey
    }
    return [job.configuration.primaryKey]
  }, [job])

  if (assignedTarget) {
    const domainKey = Array.isArray(assignedTarget.definition?.domainKey)
      ? assignedTarget.definition.domainKey
      : assignedTarget.definition?.domainKey ? [assignedTarget.definition.domainKey] : []

    return (
      <div>
        <div style={targetManagedNoteStyle}>
          Domain keys are managed by the provisioned target{' '}
          <Link to={`/admin/denali/integrator/targets/${assignedTarget.provisionedTargetTableId}`}>
            {assignedTarget.tableName}
          </Link>.
        </div>
        {domainKey.length > 0 && (
          <BasicTable>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Path</th>
              </tr>
            </thead>
            <tbody>
              {domainKey.map(key => (
                <tr key={`domain_key_${key.name}`}>
                  <td>{key.name}</td>
                  <td>{key.type}</td>
                  <td style={{ opacity: 0.6 }}>{key.path || '\u2014'}</td>
                </tr>
              ))}
            </tbody>
          </BasicTable>
        )}
      </div>
    )
  }

  if (!primaryKeys?.length) {
    return (
      <div>
        No Keys Defined
      </div>
    )
  }

  return (
    <div>
      <BasicTable>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {primaryKeys.map(key => (
            <tr key={`primary_key_${key.name}`}>
              <td>{key.name}</td>
              <td>{key.type}</td>
            </tr>
          ))}
        </tbody>
      </BasicTable>
    </div>
  )
}

JobPrimaryKeys.propTypes = {
  job: PropTypes.shape({
    configuration: PropTypes.shape({
      primaryKey: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    })
  }),
  assignedTarget: PropTypes.object
}

export default JobPrimaryKeys
